import { useCallback, useEffect, useRef } from "react";
import { AppState, Platform } from "react-native";

const INACTIVE_STATE = Platform.select({
  ios: "inactive",
  default: "background",
});

const ACTIVE_STATE = "active";

export function AppStateWatcher({ onAppBecomesActive }) {
  const prev = useRef(AppState.currentState);
  const handler = useCallback((state) => {
    if (prev.current === INACTIVE_STATE && state === ACTIVE_STATE) {
      if (onAppBecomesActive) {
        onAppBecomesActive();
      }
    }

    prev.current = state;
  }, []);

  useEffect(() => {
    AppState.addEventListener("change", handler);
    return () => AppState.removeEventListener("change", handler);
  }, []);

  return null;
}
